import React, { useMemo } from "react";

import { DiaryContainer } from "../../shared/DiaryContainer";
import { DiaryHeader } from "../../shared/DiaryHeader";
import { getDiaryEventsFromDespatchTasks } from "Util/calendar";

import { DiaryCalendar, CalendarEvent, DiaryType } from "../../../../../../components/DiaryCalendar";
import TaskBadge from "../../TaskBadge";
import { useOperationDespatchContext } from "../../../../contexts/DespatchContext";

export const DiaryMonthView = React.forwardRef(() => {
  const { tasksFiltered, isFetchingTasks, currentDate, setCurrentDate, seeTasksModalRef } =
    useOperationDespatchContext();

  const events = useMemo(() => {
    return getDiaryEventsFromDespatchTasks(tasksFiltered);
  }, [tasksFiltered]);

  const onSeeTasks = (allEvents: CalendarEvent[], date?: Date) => {
    const taskResources = allEvents.map((event) => event?.resource?.task)?.filter(Boolean);

    seeTasksModalRef.current?.open(taskResources, date);
  };

  return (
    <DiaryContainer>
      <DiaryHeader />

      <DiaryCalendar
        events={events}
        viewMode={DiaryType.MONTH}
        loadingEvents={isFetchingTasks}
        date={currentDate}
        onChangeDate={setCurrentDate}
        onShowMoreEvents={onSeeTasks}
        badgeComponent={TaskBadge}
        onSelectEvent={(event) => onSeeTasks([event])}
      />
    </DiaryContainer>
  );
});
